import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'shalala';

import { useStore } from '../../../../store';
import { Http, Event } from '../../../../support';
import Table from '../../../../facturotopia/table/Table';
import ComprobantesItemStatus from './components/ComprobantesListItemStatus';

class ComprobantesList extends Component {
  state = {};

  constructor(props) {
    super(props);

    this.state = {
      columns: this.columns,
      selectedRowKeys: [],
    };

    Event.on('app.refresh', this.handleOnAppNeedsRefresh);
  }

  componentDidMount() {
    const { data } = this.props.list;

    if (data.length === 0) {
      const from = moment().subtract(7, 'days').format('YYYY-MM-DD');
      const to = moment().format('YYYY-MM-DD');

      this.paginate({
        page: 1,
        from,
        to,
      });
    }
  }

  componentWillUnmount() {
    Event.off('app.refresh', this.handleOnAppNeedsRefresh);
  }

  get columns() {
    return [
      {
        align: 'center',
        key: 'status',
        title: 'Status',
        dataIndex: 'status',
        render: (item) => <ComprobantesItemStatus data={item} />,
      },
      {
        key: 'timbrado_at',
        title: 'Fecha',
        dataIndex: 'timbrado_at',
      },
      {
        key: 'tipo',
        title: 'Tipo',
        dataIndex: 'tipo',
      },
      {
        key: 'emisor_rfc',
        title: 'Emisor',
        dataIndex: 'emisor_rfc',
      },
      {
        key: 'receptor_rfc',
        title: 'Receptor',
        dataIndex: 'receptor_rfc',
      },
      {
        key: 'total',
        title: 'Total',
        dataIndex: 'total',
      },
      {
        key: 'uuid',
        title: 'Folio Fiscal',
        dataIndex: 'uuid',
      },
    ];
  }

  handleOnAppNeedsRefresh = () => {
    this.paginate(1);
  };

  paginate(meta = {}) {
    const { filters } = this.props.list;

    this.props.listActions.paginate({
      ...filters,
      ...meta,
    });
  }

  handleOnPageChange = (page) => {
    this.paginate({ page });
  };

  handleOnPageLimitChange = (limit) => {
    this.paginate({ limit, page: 1 });
  };

  handleRowSelectionChange = ({ selectedRowKeys, selectedRows }) => {
    this.setState(
      {
        selectedRows,
        selectedRowKeys,
      },
      () => {
        const { onRowSelectionChange } = this.props;

        onRowSelectionChange && onRowSelectionChange({ selectedRowKeys, selectedRows });
      }
    );
  };

  handleDownload = async (uuid) => {
    try {
      const response = await Http.get(`api/comprobantes/${uuid}`);

      window.location = response.data.link;
    } catch (error) {}
  };

  getRowSelectionConfig = () => {
    const { selectedRowKeys } = this.state;
    const { selectable } = this.props;

    if (!selectable) {
      return null;
    }

    return {
      type: 'checkbox',
      selectedRowKeys,
      onChange: this.handleRowSelectionChange,
      getCheckboxProps: (record) => ({
        disabled: record.name === 'Disabled User', // Column uration not to be checked
        name: record.name,
      }),
    };
  };

  getPaginationConfig() {
    const { pagination } = this.props.list;

    return {
      metadata: pagination,
      onPageChange: this.handleOnPageChange,
      onPageLimitChange: this.handleOnPageLimitChange,
    };
  }

  render() {
    const { columns } = this.state;
    const { onRowClick } = this.props;
    const { data, busy } = this.props.list;

    return (
      <Table
        loading={busy}
        columns={columns}
        rowKey={'id'}
        data={data}
        pagination={this.getPaginationConfig()}
        rowSelection={this.getRowSelectionConfig()}
        onRowClick={onRowClick}
      ></Table>
    );
  }
}

const mapState = (store) => {
  return { list: store.external.receptores.comprobantes.list };
};

const mapActions = (actions) => {
  return { listActions: actions.external.receptores.comprobantes.list };
};

export default connect(useStore, mapState, mapActions)(ComprobantesList);
